import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MdReport } from 'react-icons/md';
import '../styles/reports.scss';

export const Reports = () => {
    const user = useSelector((state) => state.userController.user);
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            navigate('/login');
        }
    }, [user, navigate]);

    return (
        <section className="reports-page">
            <div className="empty-state">
                <MdReport className="icon" />
                <h2>التقارير</h2>
                <p>هذه الصفحة قيد الإعداد وستتوفر قريباً</p>
            </div>
        </section>
    );
};

export default Reports;
